import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import {createI18n} from "vue-i18n";
import zh from './locales/zh.json'
import en from './locales/en.json'


const messages = {
    zh: zh,
    en: en,
};
const i18n = createI18n({
    locale: 'zh', // 设置默认语言
    fallbackLocale: 'zh',
    messages,
});

const app = createApp(App)
app.use(ElementPlus)
app.use(i18n);
app.mount('#app')
